// @flow

export const ADULTS_COUNT = 'adultsCount';
export const ARRIVAL = 'arrival';
export const ASCENDING = 'ascending';
export const BATHROOMS = 'bathrooms';
export const BATHROOMS_REFINEMENT = 'Bathrooms'; // legacy bathroom slot refinement
export const BEDROOMS = 'bedrooms';
export const BEDROOMS_REFINEMENT = 'Bedrooms'; // legacy bedrooms slot refinement
export const CHILDREN_COUNT = 'childrenCount';
export const DEPARTURE = 'departure';
export const FILTER = 'filter';
export const FROM_DATE = 'from-date';
export const KEYWORDS = 'keywords';
export const MAX_BATHROOMS = 'maxBathrooms';
export const MAX_BEDROOMS = 'maxBedrooms';
export const MAX_NIGHTLY_PRICE = 'maxNightlyPrice';
export const MAX_PRICE = 'maxprice';
export const MAX_SLEEPS = 'maxSleeps';
export const MAX_TOTAL_PRICE = 'maxTotalPrice';
export const MIN_BATHROOMS = 'minBathrooms';
export const MIN_BEDROOMS = 'minBedrooms';
export const MIN_NIGHTLY_PRICE = 'minNightlyPrice';
export const MIN_PRICE = 'minprice';
export const MIN_SLEEPS = 'minSleeps';
export const MIN_TOTAL_PRICE = 'minTotalPrice';
export const NE_LAT = 'neLat';
export const NE_LONG = 'neLong';
export const ORDER_BY = 'orderBy';
export const PAGE = 'page';
export const PET_INCLUDED = 'petIncluded';
export const QUERY = 'q';
export const REGION = 'region';
export const SEARCH_TERM_UUID = 'searchTermUuid';
export const SLEEPS = 'sleeps';
export const SW_LAT = 'swLat';
export const SW_LONG = 'swLong';
export const TO_DATE = 'to-date';
export const VIEW = 'view';
export const ZOOM = 'zoom';
